<template lang="pug">
v-main
  v-container(fluid)
    v-flex
      v-card
        v-toolbar.elevation-0(color="white")
          v-toolbar-title(v-model="title") Management Account
          v-spacer
          v-btn(
            class="ma-2"
            outlined
            color="blue"
            to="/upload-users"
          ) 
            v-icon.mr-1 cloud_upload 
            | upload
          v-btn(color="blue-secondary", to="/users/admin/bu/create" class="elevation-0") CREATE
        v-divider
        v-toolbar.elevation-0.mt-2.mb-4(color="white")
          v-select.hidden-sm-and-down.col-4.pl-0(
            label="Business Unit",
            :items="bisnis_unit",
            v-model="bisnisUnit",
            hide-details
          )
          span.pr-2
          v-select.hidden-sm-and-down.col-4.pl-0(
            label="Status",
            :items="dataStatus",
            v-model="status",
            hide-details
          )
          span.pr-2
          v-text-field.hidden-sm-and-down.col-4(
            flat,
            append-icon="search",
            placeholder="Keyword (optional)",
            v-model="keyword",
            hide-details
          )
        v-divider
        v-card-text.pa-0
          v-data-table(
            :headers="dataHeaders",
            :items="dataItems",
            :search="keyword"
          )
            template(v-slot:item.data-table-expand="{ headers, item }")
              v-icon.mr-2(
                title="edit",
                color="green",
                @click="onEdit(item.id, item.user_id)"
              )
                | edit


            template(v-slot:no-data)
              div.pa-15 
                img(src="../assets/icon/empty-users.png")
                div(class="empty__title mt-1") Data not found
                div(class="empty__subtitle") Data is empty or Try adjusting your filters.

            template(v-slot:no-results)
              div.pa-15 
                img(src="../assets/icon/empty-users.png")
                div(class="empty__title mt-1") Data not found
                div(class="empty__subtitle") Data is empty or Try adjusting your filters.
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "UsersBisnisUnitList",
  props: {
    title: String,
  },
  data() {
    return {
      keyword: "",
      dataStatus: ["All", "Active", "Non Active"],
      dataHeaders: [
        { text: "Name", value: "full_name" },
        { text: "Alias Name", value: "alias" },
        { text: "Position", value: "position" },
        {
          text: "Business Unit",
          value: "business_unit.bu_name",
          filter: this.searchBisnisUnit,
        },
        { text: "Email", value: "email" },
        { text: "Phone Number", value: "msisdn" },
        { text: "Group", value: "is_admin" },
        { text: "Status", value: "is_active", filter: this.statusFilter },
        { text: "Actions", value: "data-table-expand" },
      ],
      status: "",
      dataItems: [],
      bisnis_unit: ["All"],
      bisnisUnit: "",
    };
  },
  mounted() {
    this.getDataUsers();
  },
  methods: {
    getDataUsers() {
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_API + `/business-unit/users`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          res.data.data.forEach((data) => {
            data.is_active = data.is_active ? "Active" : "Non Active";
            data.is_admin = data.is_admin ? "Admin" : "User";
          });

          this.dataItems = res.data.data;
          let bu = this.dataItems.map((val) => val.business_unit.bu_name);

          this.bisnis_unit = this.bisnis_unit.concat(bu);
        })
        .catch((err) => {
          if (err.response.data.statusCode == 401) {
            this.$store.dispatch("logout");
            return this.$router.push("/");
          } else {
            this.$toasted.error(err);
          }
        })
        .finally(() => (this.loading = false));
    },
    onEdit(item, user) {
      this.$router.push({
        path: `/users/admin/bu/edit/${item}/${user}`,
        params: { id: item, user_id: user },
      });
    },
    statusFilter(val) {
      if (this.status == "All") {
        return true;
      }

      if (!this.status) {
        return true;
      }
      return val === this.status;
    },
    searchBisnisUnit(val) {
      if (this.bisnisUnit == "All") {
        return true;
      }

      if (!this.bisnisUnit) {
        return true;
      }
      return val === this.bisnisUnit;
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>

